module.exports = __webpack_public_path__ + "static/media/12.35666e1b.jpg";